(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-h2h-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-h2h-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
const {
  buildFilter
} = svs.oddset_kambi.components.kambiWidgetUtils;
const ENETPULSE_FILTER = {
  fotboll: [],
  handboll: [],
  ishockey: {
    nhl: [],
    ahl: [],
    vm: [],
    'olympiska-vinterspelen': [],
    finland: ['liiga'],
    schweiz: ['nla'],
    tyskland: ['del-bundesliga']
  }
};
class EnetpulseH2hWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.enetpulseH2H, WIDGET_TAG.enetpulseH2H, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.enetpulseH2H,
        order: 1,
        filter: "^(?!.*/esports).*".concat(buildFilter(ENETPULSE_FILTER))
      }]
    }, {
      live: false
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.EnetpulseH2hWidgetDefinition', EnetpulseH2hWidgetDefinition);

 })(window);